import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\Partners\UpdateDossierEnaosOnlineController::__invoke
* @see app/Http/Controllers/Dossier/Partners/UpdateDossierEnaosOnlineController.php
* @route '/api/dossier/{dossier}/enaos/online'
*/
const UpdateDossierEnaosOnlineController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDossierEnaosOnlineController.url(args, options),
    method: 'put',
})

UpdateDossierEnaosOnlineController.definition = {
    methods: ["put"],
    url: '/api/dossier/{dossier}/enaos/online',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Dossier\Partners\UpdateDossierEnaosOnlineController::__invoke
* @see app/Http/Controllers/Dossier/Partners/UpdateDossierEnaosOnlineController.php
* @route '/api/dossier/{dossier}/enaos/online'
*/
UpdateDossierEnaosOnlineController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return UpdateDossierEnaosOnlineController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Partners\UpdateDossierEnaosOnlineController::__invoke
* @see app/Http/Controllers/Dossier/Partners/UpdateDossierEnaosOnlineController.php
* @route '/api/dossier/{dossier}/enaos/online'
*/
UpdateDossierEnaosOnlineController.put = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDossierEnaosOnlineController.url(args, options),
    method: 'put',
})

export default UpdateDossierEnaosOnlineController